<template>
  <Badge class="mts-base-badge" v-bind="getBindValue" />
</template>

<script setup lang="ts">
  import { Badge, BadgeProps } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { Option } from '@mts-fe/types';
  import { CellProps } from '@mts/components/Table';
  import type { MColor } from '..';

  defineOptions({
    name: 'BaseBadge',
    inheritAttrs: false,
  });

  interface BaseBadgeProps extends Partial<CellProps>, Omit<BadgeProps, 'text'> {
    value?: unknown;
    options?: (Option & { color?: MColor | BadgeProps['color'] })[];
  }
  const props = withDefaults(defineProps<BaseBadgeProps>(), { options: () => [] });

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    const { text, record, column, index, value, options, ...restProps } = props;

    const curItem = options.find((i) => i.value == props.text?.toString());

    return {
      ...attrs,
      ...restProps,
      status: curItem?.color || props.status || 'default',
      text: curItem?.label || value || text,
    } as BadgeProps;
  });
</script>

<style lang="less">
  @import (reference) '@mts/design/color.less';

  .mts-base-badge {
    each(@mts-color-map, {
      .ant-badge-status-@{key}{
        background-color: @value;
      }
    });
  }
</style>
